// DS1.7
import React from 'react';
import c from 'classnames';
import s from './DotIndicator.scss';

interface Props {
  color?: 'green' | 'red';
  className?: string;
}

const DotIndicator: React.FC<Props> = ({ color = 'green', className }) => {
  return <div className={c(s['root'], s[`color-${color}`], className)} />;
};
DotIndicator.displayName = 'DotIndicator';

export default DotIndicator;
